export default "/static/images/build_roof_5.png?14f652a9fece81037bbf09298a088894";